import React from 'react';
import Box from '@tds/core-box';
import HairlineDivider from '@tds/core-hairline-divider';
import Paragraph from '@tds/core-paragraph';

import { ContentWrapper } from '../design/css';

const Success = () => {
  return (
    <>
      <Box between={4}>
        <HairlineDivider />
        <HairlineDivider />
      </Box>
      <div className="container 85%">
        <ContentWrapper style={{ minHeight: 'auto' }}>
          <Paragraph>
            Thank you for choosing TELUS Fully Managed. Our Managed IT services
            support your day-to-day IT needs so you can stay focused on what's
            important. We have received confirmation of the customer agreement
            and will proceed with setting up your solution as requested.
          </Paragraph>
          <br />
          <Paragraph>
            The next step is for you to complete our Customer Activation Form,
            located here:{' '}
            <a
              href="https://forms.office.com/pages/responsepage.aspx?id=RNW-_drO10WnY9xoJQTfFzZ_a5qDdzROuvwnPq9obT9URjAzSjVGREtUR09aN0ZGSU8wUEo1SkhMWi4u"
              target="_blank"
              rel="noreferrer"
            >
              Customer Activation Form
            </a>
          </Paragraph>
          <br />
          <Paragraph>
            If you have questions about your TELUS Fully Managed solution,
            please contact your Account Manager.
          </Paragraph>
        </ContentWrapper>
      </div>
    </>
  );
};

export default Success;
